class Room {
  width = 0;
  height = 0;

  targetWidth = 1000;
  targetHeight = 500;
  subWidth = 63;
  subHeight = 63;
  idx = -1;
  isOnBorder = false;
  borderMargin = 15;
  fmax = 100;
  ds = 228;
  df = 257;
  subPositions = [];

  //////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////
  constructor(width, height, subWidth=false, subHeight=false, targetWidth=false, targetHeight=false) {
    this.width = width;
    this.height = height;

    if (subWidth !== false)
      this.subWidth = subWidth;
    if (subHeight !== false)
      this.subHeight = subHeight;

    this.targetWidth = targetWidth !== false ? targetWidth : this.width;
    this.targetHeight = targetHeight !== false ? targetHeight : this.height;

    // this.calculateDs();

    this.setIdx();
    this.setBorderBool();
  }
  //////////////////////////////////////////////////////////////
  // calculeDs () {
  // this.ds = 5543;
  // }
  //////////////////////////////////////////////////////////////
  updateTargetSize(targetWidth, targetHeight) {
    this.targetWidth = targetWidth;
    this.targetHeight = targetHeight;

    this.setIdx();
    this.setBorderBool();
  }
  //////////////////////////////////////////////////////////////
  getRoomSize(){
    return { width: this.width, height: this.height };
  }
  //////////////////////////////////////////////////////////////
  updateRoomSize(width, height) {
    this.width = width;
    this.height = height;

    this.setIdx();
    this.setBorderBool();

    return;
  }
  //////////////////////////////////////////////////////////////
  calculateIdx(width, height) {  
    let idx = 3; // 2x3 area - yellow area - default (change default)
    if (height > 2*this.ds && width > 3*this.ds) {
      idx = -2; // room dimensions are too large - top right gray area 
    }
    else if (height > width || (width > 3*this.ds && height < (1/3)*width)){
      idx = -1; // The ratio height/width is uncommon (room too high w.r.t width or too wide w.r.t height) - top left and bottom right gray areas
    }
    else if (height <=  this.df && width <= 2 * this.df && !(height > this.ds && width > 2 * this.ds)) {
      idx = 0; // 1x2 layout - blue area
    } 
    else if ((width > 2 * this.ds && width <= 2 * this.df && height <= (1/2) * width) || (width > 2 * this.df && width <= 3 * this.ds && height <= this.df)) {
      idx = 1; // 1x3 layout - red area
    } 
    else if (width <= 2 * this.ds || (width > 2 * this.ds && width <= 2 * this.df && height < 2 * this.ds)) {
      idx = 2; // 2x2 layout - green area
    } 

    return idx;
  }
  //////////////////////////////////////////////////////////////
  getIdx() {
    return this.idx;
  }
  //////////////////////////////////////////////////////////////
  setIdx() {
    let idx = this.calculateIdx(this.width, this.height);
    if (this.idx !== idx)
      this.idx = idx;

    this.calculateSubsPosition()
  }
  //////////////////////////////////////////////////////////////
  getBorderBool() {
    return this.isOnBorder;
  }
  //////////////////////////////////////////////////////////////
  setBorderBool() {
    let idxRight = this.calculateIdx(this.width + this.borderMargin, this.height);
    let idxTop = this.calculateIdx(this.width, this.height + this.borderMargin);
    if (this.idx >= 0 && (idxRight != this.idx || idxTop != this.idx)) {
      this.isOnBorder = true;
    }
    else {
      this.isOnBorder = false;
    }
  }
  //////////////////////////////////////////////////////////////
  calculateSubsPosition() {
    if (!this.idx && this.idx !== 0) return;

    let subs = [];
    let lines = [];
    let arrows = [];

    let nbRows = 0;
    let nbCol = 0;

    if (this.idx < 0)
      return;

    if (this.idx === 0) {
      nbRows = 1;
      nbCol = 2;
    }
    else if (this.idx === 1) {
      nbRows = 1;
      nbCol = 3;
    }
    else if (this.idx === 2) {
      nbRows = 2;
      nbCol = 2;
    }
    else if (this.idx === 3) {
      nbRows = 2;
      nbCol = 3;
    }
    for (let i = 0; i < nbRows; i++) {
      for (let j = 0; j < nbCol; j++) {
        subs.push({
          id: "s_" + this.idx + "_" + ((i * nbCol) + j),
          label: "S" + ((i * nbCol) + j + 1),
          row: i,
          col: j,
          x: (this.targetWidth * (2 * j + 1) / (2 * nbCol)) - (this.subWidth / 2),
          y: (this.targetHeight * (2 * i + 1) / (2 * nbRows))  - (this.subHeight / 2)
        })
      }
    }

    this.subPositions = subs;

    // Arrows from side subs to left and right walls
    for (let i = 0; i < nbRows; i++) {
      lines.push({
        x1: 0,
        y1: subs[nbCol * i].y + this.subHeight / 2,
        x2: subs[nbCol * i].x,
        y2: subs[nbCol * i].y + this.subHeight / 2,
        direction: 'horizontal'
      });
        lines.push({
        x1: this.targetWidth,
        y1: subs[nbCol * (i + 1) - 1].y + this.subHeight / 2,
        x2: subs[nbCol * (i + 1) - 1].x + this.subWidth,
        y2: subs[nbCol * (i + 1) - 1].y + this.subHeight / 2,
        direction: 'horizontal'
      });        
    }
    // Arrows from bottom/top subs to the floor/ceiling walls
    for (let j = 0; j < nbCol; j++) {
      lines.push({
        y1: 0,
        x1: subs[nbCol * (nbRows - 1) + j].x + this.subWidth / 2,
        y2: subs[j].y,
        x2: subs[nbCol * (nbRows - 1) + j].x + this.subWidth / 2,
        direction: 'vertical'
      });
        lines.push({
        y1: this.targetHeight,
        x1: subs[nbCol * (nbRows - 1) + j].x + this.subWidth / 2,
        y2: subs[nbCol * (nbRows - 1) + j].y + this.subHeight,
        x2: subs[nbCol * (nbRows - 1) + j].x + this.subWidth / 2,
        direction: 'vertical'
      });        
    }
    // Horizontal lines between subs
    for (let i = 0; i < nbRows; i++) {
      for (let j = 0; j < nbCol - 1; j++) {
        lines.push({
          x1: subs[nbCol * i + j].x + this.subWidth,
          y1: subs[nbCol * i + j].y + this.subHeight / 2,
          x2: subs[nbCol * i + j + 1].x,
          y2: subs[nbCol * i + j + 1].y + this.subHeight / 2,
          direction: 'horizontal'
        });
      }
    }
    // Vertical lines between subs
    for (let i = 0; i < nbRows - 1; i++) {
      for (let j = 0; j < nbCol; j++) {
        lines.push({
          x1: subs[nbCol * i + j].x + this.subWidth / 2,
          y1: subs[nbCol * i + j].y + this.subHeight,
          x2: subs[nbCol * i + j + nbCol].x + this.subWidth / 2,
          y2: subs[nbCol * i + j + nbCol].y,
          direction: 'vertical'
        });
      }
    }
    this.lines = lines;

    /////////////////////////////////////////////////////////////
    let distLeft = Math.round(10 * (this.width / nbCol) / 2) / 10;
    let distRight = distLeft;
    let distMidX = 2 * distLeft;
    // 
    let distBottom = Math.round(10 * (this.height / nbRows) / 2) / 10;
    let distTop = distBottom;
    let distMidY = 2 * distBottom;  
    let verticalArrowOffset = 20;
    let horizontalArrowOffset = this.targetHeight - 35;

    // vertical arrow on the left side, between the top sub and the ceiling
    arrows.push({
      x1: verticalArrowOffset,
      y1: 0,
      x2: verticalArrowOffset,
      y2: subs[0].y + this.subHeight / 2,
      lineLength: distTop,
      direction: 'vertical'
    });      
    // vertical arrow on the left side, between the bottom sub and the floor
    arrows.push({
      x1: verticalArrowOffset,
      y1: subs[nbCol * (nbRows - 1)].y + this.subHeight / 2,
      x2: verticalArrowOffset,
      y2: this.targetHeight,
      lineLength: distBottom,
      direction: 'vertical'
    });
    // vertical arrow(s) on the left side, between horizontal sub lines
    for (let i = 0; i < nbRows - 1; i++) {
      arrows.push({
        x1: verticalArrowOffset,
        y1: subs[nbCol * i].y + this.subHeight / 2,
        x2: verticalArrowOffset,
        y2: subs[nbCol * (i + 1)].y + this.subHeight / 2,
        lineLength: distMidY,
        direction: 'vertical'
      });
    }
    // horizontal arrow top left
    arrows.push({
      x1: 0,
      y1: horizontalArrowOffset,
      x2: subs[0].x + this.subWidth / 2,
      y2: horizontalArrowOffset,
      lineLength: distLeft,
      direction: 'horizontal'
    });      
    // horizontal arrow top right
    arrows.push({
      x1: subs[nbCol - 1].x + this.subWidth / 2,
      y1: horizontalArrowOffset,
      x2: this.targetWidth,
      y2: horizontalArrowOffset,
      lineLength: distRight,
      direction: 'horizontal'
    });
    // horizontal arrow(s) top center
    for (let j = 0; j < nbCol - 1; j++) {
      arrows.push({
        x1: subs[j].x + this.subWidth / 2,
        y1: horizontalArrowOffset,
        x2: subs[j + 1].x + this.subWidth / 2,
        y2: horizontalArrowOffset,
        lineLength: distMidX,
        direction: 'horizontal'
      });
    }

    this.arrows = arrows;

    return;
  }
  //////////////////////////////////////////////////////////////
  getSubPositions() {
    return this.subPositions;
  }
  //////////////////////////////////////////////////////////////
  getArrows() {
    return this.arrows;
  }
  //////////////////////////////////////////////////////////////
  getLines() {
    return this.lines;
  }
  //////////////////////////////////////////////////////////////
  getSubSize() {
    return { width: this.subWidth, height: this.subHeight };
  }
  //////////////////////////////////////////////////////////////
  getTargetSize() {
    return { width: this.targetWidth, height: this.targetHeight };
  }
}
//////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////
module.exports.Room = Room;